
<div fxLayout="row" fxLayoutAlign="start center" mat-dialog-title>

  <h2 class="text-2xl" fxFlex="auto">
    Body Parts
  </h2>
  <!-- <div fxFlex="auto"></div> -->
  <div class="px-1" fxFlex="auto">
    <div class="bg-card rounded-full border px-4 " fxFlex="340px" fxFlex.lt-md="auto" fxHide.xs fxLayout="row"
      fxLayoutAlign="start center" style="background-color: #E5EAF4 !important">
      <input [formControl]="searchControl" class="px-4 py-3 border-0 outline-none w-full bg-transparent" placeholder="Search by body part" type="search" />
      
      <ic-icon [icIcon]="icSearch" size="18px" style="color: #0c2c6c !important"></ic-icon>
    </div>
  </div>

  <button class="text-secondary" mat-dialog-close mat-icon-button type="button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div fxLayout="row" fxLayoutAlign="space-between center" class="search-container">

  <mat-menu #filterMenu="matMenu" class="px-2 py-4" fxFlex="auto">
    <button
      mat-menu-item
      [class.selected]="selectedFilter === 'Orthopedics'"
      (click)="applyFilter('Orthopedics')"
    >
    Orthopaedic Surgery
    </button>
    <button
      mat-menu-item
      [class.selected]="selectedFilter === 'Orthopaedic Spine Surgery'"
      (click)="applyFilter('Orthopaedic Spine Surgery')"
    >
    Orthopaedic Spine Surgery
    </button>
    <button
      mat-menu-item
      [class.selected]="selectedFilter === 'Orthopaedic Hand Surgery'"
      (click)="applyFilter('Orthopaedic Hand Surgery')"
    >
    Orthopaedic Hand Surgery
    </button>
    <button
      mat-menu-item
      [class.selected]="selectedFilter === 'Pain Management'"
      (click)="applyFilter('Pain Management')"
    >
    Pain Management
    </button>
    <button
      mat-menu-item
      [class.selected]="selectedFilter === 'Physiatry'"
      (click)="applyFilter('Physiatry')"
    >
    Physiatry
    </button>
    <button
      mat-menu-item
      [class.selected]="selectedFilter === 'Anesthesiology'"
      (click)="applyFilter('Anesthesiology')"
    >
    Anesthesiology
    </button>
    <button
      mat-menu-item
      [class.selected]="selectedFilter === 'Neurosurgery'"
      (click)="applyFilter('Neurosurgery')"
    >
    Neurosurgery
    </button>
  </mat-menu>
  <button mat-button [matMenuTriggerFor]="filterMenu" class="filter-button">
    <mat-icon>filter_list</mat-icon>
    {{ selectedFilter | titlecase }}
    <mat-icon>arrow_drop_down</mat-icon>
  </button>

</div>
<mat-dialog-content>
  <div *ngIf="isLoading" fxLayout="column" fxLayoutAlign="center center" class="centered-content">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>

  <ng-container *ngIf="!isLoading">
    <div class="tab-buttons mt-4 flex gap-4">
      <button mat-button (click)="selectTab('all')" [class.active]="selectedTab === 'all'">
        <mat-icon *ngIf="selectedTab === 'all'">check</mat-icon> All
      </button>
      <button mat-button (click)="selectTab('Right')" [class.active]="selectedTab === 'Right'">
        <mat-icon *ngIf="selectedTab === 'Right'">check</mat-icon> Right
      </button>
      <button mat-button (click)="selectTab('Left')" [class.active]="selectedTab === 'Left'">
        <mat-icon *ngIf="selectedTab === 'Left'">check</mat-icon> Left
      </button>

      <button mat-button (click)="selectTab('Bilateral')" [class.active]="selectedTab === 'Bilateral'">
        <mat-icon *ngIf="selectedTab === 'Bilateral'">check</mat-icon> Bilateral
      </button>
      <button mat-button (click)="selectTab('Unspecified')" [class.active]="selectedTab === 'Unspecified'">
        <mat-icon *ngIf="selectedTab === 'Unspecified'">check</mat-icon>
        Unspecified
      </button>

    </div>


    <div *ngIf="filteredParts.length === 0 && !isLoading" fxLayout="column" fxLayoutAlign="center center"
      class="centered-content">
      <img class="h-40 mt-2" src="assets/img/illustrations/idea.svg" alt="No data" />
      <h2 class="headline m-0 text-center">Data not found</h2>
    </div>

    <mat-selection-list *ngIf="filteredParts.length > 0" #bodyPartList class="three-column-list mt-3">
      <div class="column">
        <mat-list-option *ngFor="let part of getPartsForColumn(1)" [value]="part" [selected]="isSelected(part)"
          (click)="toggleSelection(part)">
          {{ part }}
        </mat-list-option>
      </div>
      <div class="column">
        <mat-list-option *ngFor="let part of getPartsForColumn(2)" [value]="part" [selected]="isSelected(part)"
          (click)="toggleSelection(part)">
          {{ part }}
        </mat-list-option>
      </div>
      <div class="column">
        <mat-list-option *ngFor="let part of getPartsForColumn(3)" [value]="part" [selected]="isSelected(part)"
          (click)="toggleSelection(part)">
          {{ part }}
        </mat-list-option>
      </div>
    </mat-selection-list>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions class="justify-end">
  <button mat-button class="blue-back" (click)="onCancel()">
    Cancel
  </button>
  <button mat-raised-button class="markAs-complete" (click)="onSave()">
    Save
  </button>
</mat-dialog-actions>